import axios from "axios";

import sar_for_white_theme from "../src/images/sar_for_white_theme.svg";
import sar_for_dark_theme from "../src/images/sar_for_dark_theme.svg";

export const FCM_TOKEN = "emrDNE9HT6CPp4zLHNud2D:APA91bG38qZDtmago4BR75an7y90JWZmcFLxZCzg_Jlk9ryO5pAbaMLzC2AUyLcNwYdlQnnaOeWIPBG0whyUnUUdMnYnM5cHa_OHgdz_gcchW8xQZP8bjkg";

export const GetTextFontByLang = ($type) => {
  const language = getLocalStorageMenuItem("lang");

  if (language === "ar" || language === "fa") {
    if ($type === "h") {
      return "lang_ar_head";
    } else if ($type === "s") {
      return "lang_ar_sub";
    } else {
      return "";
    }
  } else {
    if ($type === "h") {
      return "lang_head";
    } else if ($type === "s") {
      return "lang_sub";
    } else {
      return "";
    }
  }
};

export const SetTextAlignByLang = () => {
  const language = getLocalStorageMenuItem("lang");
  if (language === "ar" || language === "fa") {
    return "rtl text-end";
  } else {
    return "ltr text-start";
  }
};

export const SetPrimaryBackgroundByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  if (mode === "dark") {
    return "dark-mode-primary-background";
  } else {
    return "primary-background";
  }
};

export const SetSecondryBackgroundByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  if (mode === "dark") {
    return "dark-mode-secandory-background";
  } else {
    return "secondary-background";
  }
};

export const SetThirdBackgroundByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  if (mode === "dark") {
    return "dark-mode-third-background";
  } else {
    return "gray-background";
  }
};

export const SetPrimaryColorByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  if (mode === "dark") {
    return "primary-color";
  } else {
    return "dark-color";
  }
};

export const SetSecondryColorByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  if (mode === "dark") {
    return "gray-color";
  } else {
    return "secondary-color";
  }
};

export const setMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  if (mode === "dark") {
    return "dark";
  } else {
    return "light";
  }
};
export const setLang = () => {
  const lang = getLocalStorageMenuItem("lang");
  if (lang === "ar" || lang === "fa") {
    return "arabic-font";
  } else {
    return "latino-font";
  }
};

export const setMobileTextColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#E0E1DD";
  } else if (theme === "light") {
    return "#041731";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("textColor");
  } else {
    return "#041731";
  }
};

export const setMobileHighlightTextColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#E0E1DD";
  } else if (theme === "light") {
    return "#041731";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("textOnHighlights") || "#FFFFFF";
  } else {
    return "#041731";
  }

};

export const setMobileSubTextColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#426CA5";
  } else if (theme === "light") {
    return "#426CA5";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("textColor");
  } else {
    return "#426CA5";
  }
};

export const setMobileBackColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#000205";
  } else if (theme === "light") {
    return "#F2F4F7";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("backColor");
  } else {
    return "#F2F4F7";
  }
};

export const setMobileCardColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#020E1D";
  } else if (theme === "light") {
    return "#F0F6FE";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("cardColor");
  } else {
    return "#F0F6FE";
  }
};

export const setMobileCardBorderColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#6BA5F2";
  } else if (theme === "light") {
    return "#6BA5F2";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("highlights");
    // return "#000000"
  } else {
    return "#6BA5F2";
  }
};

export const setMobileTextField_BK_FONT_Border_StyleColor = () => {
  //bgc - color - bordercolor
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return ["#020E1D", "#E0E1DD", "#D0D5DD"];
  } else if (theme === "light") {
    return ["#F9FAFB", "#98A2B3", "#D0D5DD"];
  } else if (theme === "costomize") {
    return [
      getLocalStorageMenuItem("cardColor"),
      getLocalStorageMenuItem("textColor"),
      "#D0D5DD",
    ];
  } else {
    return ["#f2f2f2", "#98A2B3"];
  }
};

export const setMobileButttonBackColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") {
    return "#6ba5f2";
  } else if (theme === "light") {
    return "#6ba5f2";
  } else if (theme === "costomize") {
    return getLocalStorageMenuItem("highlights");
  } else {
    return "#6ba5f2";
  }
};

export const getBadgeStatusClass = (status_name) => {
  const theme_type = getLocalStorageMenuItem("theme");
  var class_name =
    theme_type === "dark" ? "new-badge-style-dark" : "new-badge-style";
  if (status_name === "Excellent preparation on the table") {
    class_name =
      theme_type === "dark"
        ? "excellent-badge-style-dark"
        : "excellent-badge-style";
  } else if (status_name === "Chef's Specialty") {
    class_name =
      theme_type === "dark" ? "chef-badge-style-dark" : "chef-badge-style";
  } else if (status_name === "Most Ordered") {
    class_name =
      theme_type === "dark"
        ? "mostordered-badge-style-dark"
        : "mostordered-badge-style";
  } else if (status_name === "Suitable for diabetic patients") {
    class_name =
      theme_type === "dark"
        ? "suitable-badge-style-dark"
        : "suitable-badge-style";
  } else if (status_name === "Preferred for kids") {
    class_name =
      theme_type === "dark" ? "new-badge-style-dark" : "new-badge-style";
  } else if (status_name === "Most ordered among BBQs") {
    class_name =
      theme_type === "dark"
        ? "mostordered-badge-style-dark"
        : "mostordered-badge-style";
  }
  return class_name;
};

export const getOrderBadgeStatusClass = (status_name) => {
  const theme_type = getLocalStorageMenuItem("theme");
  var class_name = "";
  if (status_name === "cancelled") {
    class_name =
      theme_type === "dark"
        ? "cancelled-badge-style-dark"
        : "cancelled-badge-style";
  } else if (status_name === "ready") {
    class_name =
      theme_type === "dark" ? "ready-badge-style-dark" : "ready-badge-style";
  } else if (status_name === "completed") {
    class_name =
      theme_type === "dark"
        ? "completed-badge-style-dark"
        : "completed-badge-style";
  } else if (status_name === "waiting") {
    class_name =
      theme_type === "dark"
        ? "waiting-badge-style-dark"
        : "waiting-badge-style";
  } else if (status_name === "preparing") {
    class_name =
      theme_type === "dark"
        ? "preparing-badge-style-dark"
        : "preparing-badge-style";
  } else if (status_name === "at delivery") {
    class_name =
      theme_type === "dark"
        ? "at_delivery-badge-style-dark"
        : "at_delivery-badge-style";
  }
  return class_name;
};

export const buildTree = (data, parentId) => {
  const children = data.filter((item) => item.parent_id === parentId);
  return children.map((child) => ({
    ...child,
    children: buildTree(data, child.id),
  }));
};

export const sortByPosition = () => {
  return function (elem1, elem2) {
    if (elem1.position < elem2.position) {
      return -1;
    } else if (elem1.position > elem2.position) {
      return 1;
    } else {
      return 0;
    }
  };
};

export const generateRandomToken = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    token += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return token;
};

export const AllLanguagesNames = (lang) => {
  const languages = [
    { ar: "Arabic" },
    { en: "English" },
    { fr: "French" },
    { "zh-Hans": "Chinese" },
    { ca: "Catalan" },
    { hr: "Croatian" },
    { cs: "Czech" },
    { da: "Danish" },
    { nl: "Dutch" },
    { et: "Estonian" },
    { de: "German" },
    { hu: "Hungarian" },
    { it: "Italian" },
    { mk: "Macedonian" },
    { nb: "Norwegian" },
    { fa: "Persian" },
    { pt: "Portuguese-br" },
    { "pt-pt": "Portuguese-pt" },
    { ro: "Romanian" },
    { ru: "Russian" },
    { ja: "Japanese" },
    { ko: "Korean" },
    { es: "Spanish" },
    { tr: "Turkish" },
    { uk: "Ukranian" },
    { sv: "Swedish" },
  ];

  const selected = languages.filter((language) => {
    return language[lang];
  });

  if (selected[0]) {
    return selected[0][lang];
  }
};

export const AllLanguagesCode = [
  "ja",
  "ko",
  "ar",
  "en",
  "az",
  "ca",
  "zh-Hans",
  "hr",
  "cs",
  "da",
  "nl",
  "et",
  "fa",
  "fr",
  "de",
  "he",
  "hu",
  "it",
  "mk",
  "nb",
  "pt",
  "pt-pt",
  "ro",
  "ru",
  "es",
  "sv",
  "tr",
  "uk",
];

export const languagesOptions = [
  { code: "ar", label: "Arabic" },
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "zh-Hans", label: "Chinese" },
  { code: "ca", label: "Catalan" },
  { code: "hr", label: "Croatian" },
  { code: "cs", label: "Czech" },
  { code: "da", label: "Danish" },
  { code: "nl", label: "Dutch" },
  { code: "et", label: "Estonian" },
  { code: "de", label: "German" },
  { code: "hu", label: "Hungarian" },
  { code: "it", label: "Italian" },
  { code: "mk", label: "Macedonian" },
  { code: "nb", label: "Norwegian" },
  { code: "fa", label: "Persian" },
  { code: "pt", label: "Portuguese-br" },
  { code: "pt-pt", label: "Portuguese-pt" },
  { code: "ro", label: "Romanian" },
  { code: "ru", label: "Russian" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "es", label: "Spanish" },
  { code: "tr", label: "Turkish" },
  { code: "uk", label: "Ukranian" },
  { code: "sv", label: "Swedish" },
];

export const getAndSaveTimeZone = async () => {
  try {
    const timeZone = getLocalStorageMenuItem("timezone");
    const countryCode = getLocalStorageMenuItem("countryCode");
    if (!timeZone || !countryCode) {
      const promise = await axios.get(`${process.env.REACT_APP_API}/timezone`);
      if (promise.status === 200) {
        const timezoneData = promise?.data?.data?.timezone
          ? promise?.data?.data?.timezone
          : "";

        setLocalStorageMenuItem("countryCode", JSON.stringify(promise?.data?.data?.countryCode));
        setLocalStorageMenuItem("timezone", JSON.stringify(timezoneData));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const getAuth = () => {
  const token = getLocalStorageMenuItem("jwt_authorization") || getLocalStorageMenuItem("authorization");
  const language = getLocalStorageMenuItem("lang");
  const venue_id = getLocalStorageMenuItem("venueId");
  const timeZone = getLocalStorageMenuItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      venueId: venue_id,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getAuthMobile = () => {
  const token = getLocalStorageMenuItem("mobileLoginToken");
  const language = getLocalStorageMenuItem("lang");
  const timeZone = getLocalStorageMenuItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getGustAuthMobile = () => {
  const token = getLocalStorageMenuItem("gustToken");
  const language = getLocalStorageMenuItem("lang");
  const timeZone = getLocalStorageMenuItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getAuthAdmin = () => {
  const token = getLocalStorageMenuItem("authorization");
  const language = getLocalStorageMenuItem("lang");
  const venue_id = getLocalStorageMenuItem("venueId");
  const timeZone = getLocalStorageMenuItem("timezone");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      localization: language,
      venueId: venue_id,
      timeZone: timeZone.replace(/["]+/g, ''),
    },
  };
};

export const getPopupBorderRaduis = () => "12px";

export const setMobileSettings = (p_details) => {
  if (!getLocalStorageMenuItem("showOption")) {
    setLocalStorageMenuItem(
      "showOption",
      p_details.mobile_settings?.showOption
    );
  }
  if (p_details.mobile_settings?.theme === "costomize") {
    setLocalStorageMenuItem(
      "theme",
      p_details.mobile_settings?.theme
    );
    setLocalStorageMenuItem(
      "textColor",
      p_details.mobile_settings.colorProps.text
    );
    setLocalStorageMenuItem(
      "backColor",
      p_details.mobile_settings.colorProps.back
    );
    setLocalStorageMenuItem(
      "cardColor",
      p_details.mobile_settings.colorProps.card
    );
    setLocalStorageMenuItem(
      "highlights",
      p_details.mobile_settings.colorProps.highlights
    );
    setLocalStorageMenuItem(
      "textOnHighlights",
      p_details.mobile_settings.colorProps.textOnHighlights
    );
  } else {
    if (
      getLocalStorageMenuItem("theme") !== "dark" &&
      getLocalStorageMenuItem("theme") !== "light"
    ) {
      setLocalStorageMenuItem(
        "theme",
        p_details.mobile_settings?.theme
      );
    }
  }
}



export const ISDARKTHEME = (theme, hexColor) => {
  if (theme === "dark") {
    return true;
  }

  if (theme === "light") {
    return false;
  }

  // Convert Hex to RGB
  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  // Calculate Luminance
  const calculateLuminance = (r, g, b) => {
    const adjust = (channel) => {
      let c = channel / 255; // Normalize to [0, 1]
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    const rLinear = adjust(r);
    const gLinear = adjust(g);
    const bLinear = adjust(b);

    return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
  };

  // Get RGB from Hex
  const { r, g, b } = hexToRgb(hexColor);

  // Calculate Relative Luminance
  const luminance = calculateLuminance(r, g, b);

  // Determine Theme
  return luminance <= 0.5 ? true : false;
}


// export const SARIconThemeColor = () => {
//   const theme = getLocalStorageMenuItem("theme");
//   if (theme === "dark") {
//     return sar_for_dark_theme;
//   } else {
//     return sar_for_white_theme;
//   }
// };

export const SARIconThemeColor = (reverse = false) => {
  const theme = getLocalStorageMenuItem("theme");

  if (ISDARKTHEME(theme, setMobileBackColor() || getLocalStorageMenuItem("tree_data")?.details?.mobile_settings?.colorProps?.back)) {
    return reverse ? sar_for_white_theme : sar_for_dark_theme;
  } else {
    return reverse ? sar_for_dark_theme : sar_for_white_theme;
  }
};


export const sendNotificationFirebaseRes = async (detailsData, title, body, application_type) => {
  try {
    const params = new URLSearchParams(window.location.search);
    const response = await axios.post(
      `${process.env.REACT_APP_API}/send-firebase-notification`,
      {
        venue_id: detailsData?.venue_id,
        table_code: params.get("t") || "",
        title: title || "",
        body: body || "",
        application: application_type || "",
        gust_token: getLocalStorageMenuItem("gustToken"),
        data: {
          venue_id: detailsData?.venue_id,
          table: params.get("t") || "",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error sending notification:", error);
  }
}


export const fetchWalletBalance = async () => {
  try {
    const token = getLocalStorageMenuItem("mobileLoginToken");
    if (!token) return 0;

    const response = await axios.get(
      `${process.env.REACT_APP_API}/customer/wallet-balance`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );


    const balance = parseFloat(response.data.data || 0);
    setLocalStorageMenuItem("customer_balance", balance.toString());
    return balance;
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
    return 0;
  }
};

export const fetchLoyaltyPoints = async (venueId) => {
  try {
    const token = getLocalStorageMenuItem("mobileLoginToken");
    if (!token || !venueId) return { balance: 0, total_earned: 0, total_redeemed: 0 };

    const response = await axios.get(
      `${process.env.REACT_APP_API}/customer/loyalty-points?venue_id=${venueId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const pointsData = response.data.data;

    // Store in localStorage for quick access
    setLocalStorageMenuItem("loyalty_points_balance", pointsData.balance.toString());
    setLocalStorageMenuItem("loyalty_points_earned", pointsData.total_earned.toString());
    setLocalStorageMenuItem("loyalty_points_redeemed", pointsData.total_redeemed.toString());

    return {
      balance: parseFloat(pointsData.balance || 0),
      total_earned: parseFloat(pointsData.total_earned || 0),
      total_redeemed: parseFloat(pointsData.total_redeemed || 0),
      program: pointsData.program || null
    };
  } catch (error) {
    console.error("Error fetching loyalty points:", error);
    return { balance: 0, total_earned: 0, total_redeemed: 0, program: null };
  }
};

const isJSONString = (value) => {
  if (typeof value !== 'string') return false;
  try {
    const parsed = JSON.parse(value);
    // Ensure parsed is a plain object, array, string, number, boolean, or null
    return typeof parsed === 'object' || typeof parsed === 'number' || typeof parsed === 'string' || typeof parsed === 'boolean' || parsed === null;
  } catch (e) {
    return false;
  }
};


export const setLocalStorageMenuItem = (key, value) => {
  const location = window.location.href;
  const array = location.split("/");
  const menuId = array[array.length - 2];


  if (!menuId || !key) return;
  const fullKey = `${menuId}_${key}`;
  const storedValue = isJSONString(value) ? value : JSON.stringify(value);
  localStorage.setItem(fullKey, storedValue);
};

export const getLocalStorageMenuItem = (key) => {


  const location = window.location.href;
  const array = location.split("/");
  const menuId = array[array.length - 2];


  if (!menuId || !key) return null;
  const fullKey = `${menuId}_${key}`;
  const value = localStorage.getItem(fullKey);
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
};

export const removeLocalStorageMenuItem = (key) => {
  const location = window.location.href;
  const array = location.split("/");
  const menuId = array[array.length - 2];

  if (!menuId || !key) return;
  const fullKey = `${menuId}_${key}`;

  localStorage.removeItem(fullKey);
};




